<div class="screen-container">
  <div *ngIf="!isSummary; else summaryBlock">
    <app-card
      [title]="'purpose.title' | translate"
      [currentStep]="flowService.currentQuestionIndex"
      [steps]="flowService.questionsLength"
    >
      <div left-content>
        <form [formGroup]="purposeForm">
          <div left-content class="content-container">
            <app-dropdown
              [label]="'purpose.reason'"
              [control]="reason"
              [options]="reasonOptions"
              [optionsTranslationKey]="'reasonOptions'"
            ></app-dropdown>
            <div class="textarea-container">
              <app-textarea
                [label]="'purpose.reasonDescription'"
                [control]="reasonDesc"
                (blurEvent)="reasonDescriptionUpdate()"
              ></app-textarea>
            </div>
            <app-infobox
              [title]="'purpose.infobox.title' | translate"
              [content]="'purpose.infobox.content' | translate"
            >
            </app-infobox>
          </div>
        </form>
        <div actions class="navigationButtons">
          <button
            (click)="handleContinueButtonClick()"
            mat-flat-button
            color="primary"
          >
            {{ "purpose.nextButtonText" | translate }}
          </button>
          <button
            (click)="handleBackButtonClick()"
            mat-flat-button
            color="secondary"
          >
            {{ "purpose.backButtonText" | translate }}
          </button>
        </div>
      </div>
      <div right-content>
        <app-contact></app-contact>
      </div>
    </app-card>
  </div>

  <ng-template #summaryBlock>
    <div class="summary">
      <div class="content-container">
        <div class="label">{{ "purpose.title" | translate }}</div>
        <app-dropdown
          [label]="'purpose.reason'"
          [control]="reason"
          [options]="reasonOptions"
          [optionsTranslationKey]="'reasonOptions'"
        ></app-dropdown>
        <app-textarea
          [label]="'purpose.reasonDescription'"
          [control]="reasonDesc"
          (blurEvent)="reasonDescriptionUpdate()"
        ></app-textarea>
        <app-infobox
          [title]="'purpose.infobox.title' | translate"
          [content]="'purpose.infobox.content' | translate"
        >
        </app-infobox>
      </div>
    </div>
  </ng-template>
</div>
